import { Outlet, useParams } from "react-router-dom";
import "./List.css";

export default function List() {
  let id = useParams()["id"];

  return (
    <div className="list-page">
      <Outlet context={id} />
    </div>
  );
}
